exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".action-detail[data-v-4db4c796] {\n  color: #0077fa !important;\n  cursor: pointer !important;\n}\n.action-detail .forbidden[data-v-4db4c796] {\n  pointer-events: none;\n  cursor: default;\n  color: #8bc1f3;\n}\n.exportTemplate[data-v-4db4c796] {\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n", ""]);

// exports
